import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {useAppDispatch, useAppSelector} from '../../../helpers/reduxHelpers';
import {AnalyticsFilterTypesEnum} from '../../../models/api/analyticsSavedViewModel';
import {updateFiltersAction} from '../../../store/panels/analytics/filters/analyticsPanelFiltersActions';
import {makeGetAnalyticsFilter} from '../../../store/panels/analytics/filters/analyticsPanelFiltersSelectors';
import {AnalyticsPanelFiltersState} from '../../../store/panels/analytics/filters/analyticsPanelFiltersState';

/**
 * Custom hook to retrieve filters and dispatch changes.
 */

export function useAnalyticsFilter<T extends AnalyticsFilterTypesEnum>(
  type: T,
): [AnalyticsPanelFiltersState[T], HandlerOf<AnalyticsPanelFiltersState[T]>] {
  const filterValues = useAppSelector(makeGetAnalyticsFilter(type));
  const dispatch = useAppDispatch();

  const onUpdate = (newValue: AnalyticsPanelFiltersState[T]) => {
    dispatch(updateFiltersAction({[type]: newValue}));
  };

  return [filterValues, onUpdate];
}
